var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBedroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 82,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M153.2612 61.2585l-.002-57.551c0-1.566-1.201-2.835-2.683-2.835h-138.64c-1.482 0-2.682 1.27-2.682 2.835v57.56l144.007-.009z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M153.2612 61.2585l-.002-57.551c0-1.566-1.201-2.835-2.683-2.835h-138.64c-1.482 0-2.682 1.27-2.682 2.835v57.56l144.007-.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M149.2661 76.8766v-11.977h-8.007v11.991h.008c0 2.209 1.791 4 4 4s4-1.791 4-4c0-.005-.001-.009-.001-.014"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M149.2661 76.8766v-11.977h-8.008v11.991h.009c0 2.209 1.791 4 4 4s4-1.791 4-4c0-.005-.001-.009-.001-.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.2603 76.8766v-11.977h-8.007v11.991h.008c0 2.209 1.791 4 4 4s3.999-1.791 3.999-4v-.014"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M21.2603 76.8766v-11.977h-8.007v11.991h.008c0 2.209 1.791 4 4 4s3.999-1.791 3.999-4v-.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M158.3843 64.7922l-154.292.026c-1.566 0-2.835-1.269-2.835-2.834l-.002-10.309c-.001-1.566 1.268-2.835 2.834-2.836l154.293-.026c1.564 0 2.834 1.269 2.835 2.835l.001 10.309c0 1.565-1.27 2.835-2.834 2.835"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M158.3843 64.7922l-154.292.026c-1.566 0-2.835-1.269-2.835-2.834l-.002-10.309c-.001-1.566 1.268-2.835 2.834-2.836l154.293-.026c1.564 0 2.834 1.269 2.835 2.835l.001 10.309c0 1.565-1.27 2.835-2.834 2.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M76.1196 24.6222l-53.774.009c-2.785.001-5.039 2.258-5.039 5.041 0 2.783-.126 5.03 0 5.02l63.855-.01c.127.009 0-2.237-.001-5.021 0-2.783-2.257-5.039-5.041-5.039"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M76.1196 24.6222l-53.774.009c-2.785.001-5.039 2.258-5.039 5.041 0 2.783-.126 5.03 0 5.02l63.855-.01c.127.009 0-2.237-.001-5.021 0-2.783-2.257-5.039-5.041-5.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M140.1226 24.6115l-53.774.009c-2.785.001-5.039 2.258-5.039 5.041 0 2.783-.126 5.03 0 5.02l63.855-.01c.127.009 0-2.237-.001-5.021 0-2.783-2.257-5.039-5.041-5.039"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M140.1226 24.6115l-53.774.009c-2.785.001-5.039 2.258-5.039 5.041 0 2.783-.126 5.03 0 5.02l63.855-.01c.127.009 0-2.237-.001-5.021 0-2.783-2.257-5.039-5.041-5.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M145.2202 32.6408l-127.97.021c-6.624.001-11.993 5.373-11.992 11.997.001 6.624-.301 4.217.002 4.194l151.958-.025c.302.022-.001 2.429-.002-4.195-.001-6.624-5.372-11.993-11.996-11.992"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M145.2202 32.6408l-127.97.021c-6.624.001-11.993 5.373-11.992 11.997.001 6.624-.301 4.217.002 4.194l151.958-.025c.302.022-.001 2.429-.002-4.195-.001-6.624-5.372-11.993-11.996-11.992z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedroom);
export default __webpack_public_path__ + "static/media/bedroom.e288c07fbba14ef212ccb80daa8c744d.svg";
export { ForwardRef as ReactComponent };